<template>
	<div style="display: flex;flex-direction: column; height: 93.5vh;" class="bg-gray-50">

		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<!-- 顶部搜索区域 -->
		<div class="sticky top-0 z-50 bg-white shadow-md">
			<div class="container mx-auto px-6 py-4" style="width: 100%;">
				<div class="flex items-center gap-4" style="width: 100%;">
					<div class="relative flex-1">
						<input type="text" v-model="searchQuery"
							class="w-full h-12 pl-12 pr-4 text-sm border-none rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
							:placeholder="$t('language000211')" />
						<i class="fas fa-search absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
					</div>

					<select v-model="selectedType"
						class="h-12 px-4 border-none bg-gray-100 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
						<option value="">
							<!-- 全部类型 -->
							{{ $t('language000212') }}
						</option>
						<option v-for="type in deviceTypes" :key="type" :value="type">{{ type }}</option>
					</select>

				</div>
			</div>
		</div>


		<!-- 主要内容区域 -->
		<div class="bg-gray-50" style="padding-left: 5%; padding-right: 5%; padding-top: 20px; padding-bottom: 20px;">
			<!-- 设备列表 -->
			<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
				<div v-for="device in filteredDevices" :key="device.id"
					class="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
					<div class="h-48 overflow-hidden flex items-center justify-center p-5"
						style="background-color: rgba(0, 0, 0, 0.1);">
						<div style="width: 60%; display: flex; justify-content: center;">
							<img :src="device.image" :alt="device.name" class="h-full object-contain" />
						</div>

						<div style="width: 30%; margin-left: 15px;">
							<img :src="device.image01" :alt="device.name" class="h-full object-contain"
								style="border-radius: 10px;" />
						</div>
					</div>
					<div class="p-6">
						<div class="flex justify-between items-start mb-4">
							<h3 class="text-lg font-semibold text-gray-800">{{ device.name }}</h3>
							<span
								:class="device.status === $t('language000215') ? 'bg-green-100 text-green-600' : 'bg-gray-100 text-gray-600'"
								class="px-2 py-1 text-xs rounded">
								{{ device.status }}
							</span>
						</div>
						<p class="text-sm text-gray-600 mb-4">{{ device.description }}</p>
						<div class="flex flex-wrap gap-2 mb-4">
							<span v-for="(tag, index) in device.tags" :key="index"
								class="px-2 py-1 text-xs bg-blue-50 text-blue-600 rounded">
								{{ tag }}
							</span>
						</div>
						<div class="flex justify-between items-center">
							<span class="text-sm text-gray-500">
								<i class="fas fa-clock mr-1"></i>
								{{ $t('language000213') }}
								{{ device.lastUpdate }}
							</span>
							<button @click="goToDetail(device.id)"
								class="text-blue-500 hover:text-blue-600 !rounded-button whitespace-nowrap">
								<i class="fas fa-info-circle mr-1"></i>
								{{ $t('language000214') }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	export default {
		data() {
			return {
				searchQuery: '',
				selectedType: '',
				showBackToTop: false,
				deviceTypes: [this.$t('language000220'), this.$t('language000221')], //钥匙盒，锁
				devices: [{
					id: 18,
					name: 'Pear Flower (II)',
					description: this.$t('language000508'), //二代肛塞
					status: this.$t('language000215'), //已开放
					type: this.$t('language000221'), //锁
					tags: [this.$t('language000222'), this.$t('language000223'), this.$t('language000313'), this
						.$t('language000311')
					], //'开锁', '关锁', '震动', '电击'
					lastUpdate: '2026-4-13 10:00',
					image: require('../../../assets/anal_plug2_37.png'),
					image01: require('../../../assets/anal_plug2_3701.jpg'),
				}, {
					id: 15,
					name: 'CAGINK.metal.Shake',
					description: this.$t('language000454'), //震动金属锁
					status: this.$t('language000215'), //已开放
					type: this.$t('language000221'), //锁
					tags: [this.$t('language000222'), this.$t('language000223'), this.$t(
						'language000313')], //'开锁', '关锁', '震动'
					lastUpdate: '2025-11-25 14:00',
					image: require('../../../assets/tail20.png'),
					image01: require('../../../assets/gen_metal1601.png'),
				}, {
					id: 6,
					name: 'Key Pod (I)',
					description: this.$t('language000217'), //一代钥匙盒
					status: this.$t('language000215'), //已开放
					type: this.$t('language000220'), //钥匙盒
					tags: [this.$t('language000222'), this.$t('language000223')], //'开锁', '关锁'
					lastUpdate: '2025-02-24 16:45',
					image: require('../../../assets/image_key_pod.png'),
					image01: require('../../../assets/image_key_pod01.jpg'),
				}, {
					id: 10,
					name: 'Cag Ink (III)',
					description: this.$t('language000304'), //三代锁
					status: this.$t('language000215'), //已开放
					type: this.$t('language000221'), //锁
					tags: [this.$t('language000222'), this.$t('language000223'), this.$t('language000224'), this
						.$t('language000225')
					], //'开锁', '关锁', '蜂窝', '显示器'
					lastUpdate: '2024-02-25 12:15',
					image: require('../../../assets/image_cellmate_gen3.png'),
					image01: require('../../../assets/image_cellmate_gen301.png'),
				}, {
					id: 13,
					name: 'CAGINK.metal',
					description: this.$t('language000420'), //金属锁
					status: this.$t('language000215'), //已开放
					type: this.$t('language000221'), //锁
					tags: [this.$t('language000222'), this.$t('language000223')], //'开锁', '关锁'
					lastUpdate: '2025-05-01 10:00',
					image: require('../../../assets/gen_metal16.png'),
					image01: require('../../../assets/gen_metal1601.png'),
				}, {
					id: 2,
					name: 'Key Pod (II)',
					description: this.$t('language000218'), //二代钥匙盒
					status: this.$t('language000216'), //开发中
					type: this.$t('language000220'), //钥匙盒
					tags: [this.$t('language000222'), this.$t('language000223'), this.$t('language000224'), this
						.$t('language000225')
					], //'开锁', '关锁', '蜂窝', '显示器'
					lastUpdate: '2024-12-31 16:45',
					image: require('../../../assets/image_key_pod2.png'),
					image01: require('../../../assets/image_key_pod201.png'),
				}, {
					id: 4,
					name: 'Cag Ink (II)',
					description: this.$t('language000219'), //二代锁
					status: this.$t('language000216'), //开发中
					type: this.$t('language000221'), //锁
					tags: [this.$t('language000222'), this.$t('language000223')], //'开锁', '关锁'
					lastUpdate: '2024-01-20 12:15',
					image: require('../../../assets/image_cellmate_gen2_cg.png'),
					image01: require('../../../assets/image_cellmate_gen2_cg01.png'),
				}]
			};
		},
		computed: {
			filteredDevices() {
				return this.devices.filter(device => {
					const matchesSearch = device.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
						device.description.toLowerCase().includes(this.searchQuery.toLowerCase());
					const matchesType = !this.selectedType || device.type === this.selectedType;
					return matchesSearch && matchesType;
				});
			}
		},
		methods: {
			goToDetail(deviceId) {
				let page;
				switch (deviceId) {
					case 6: //一代钥匙盒
						page = this.$router.resolve({
							path: '/KeyBoxHome01',
							query: {}
						});
						window.open(page.href, '_blank');
						break
					case 10: //三代锁
						page = this.$router.resolve({
							path: '/Gen3Home',
							query: {}
						});
						break
					case 13: //金属锁
						page = this.$router.resolve({
							path: '/GenMetalHome',
							query: {}
						});
						break
					case 15: //震动金属锁
						page = this.$router.resolve({
							path: '/ShockGenMetalHome',
							query: {}
						});
						break
					case 18: //二代肛塞
						page = this.$router.resolve({
							path: '/Analplug2',
							query: {}
						});
						break
				}
				if (page != null) {
					window.open(page.href, '_blank');
				}
			},
			//...
		},
	};
</script>

<style scoped>
</style>